import React from 'react'

const BellIcon = () => (
  <svg aria-hidden="true" viewBox="0 0 24 24">
    <path
      d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9M9.8 20a2.4 2.4 0 0 0 4.4 0"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.8"
    />
  </svg>
)

export default BellIcon
